import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, ButtonGroup } from 'react-bootstrap';

function Payment() {
  const [tokenAmount, setTokenAmount] = useState(1); // Initialwert
  const [paymentMethod, setPaymentMethod] = useState(''); // 'paypal' oder 'paypal-credit'
  const [processingPayment, setProcessingPayment] = useState(false);
  const [paymentError, setPaymentError] = useState('');
  const [paymentSuccess, setPaymentSuccess] = useState('');

  const handleTokenChange = (event) => {
    setTokenAmount(parseInt(event.target.value, 10) || 1);
  };

  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
    setPaymentError('');
    setPaymentSuccess('');
  };

  const handlePaymentSubmit = async () => {
    if (!paymentMethod) {
      setPaymentError('Bitte wähle eine Zahlungsmethode.');
      return;
    }

    setProcessingPayment(true);
    setPaymentError('');
    setPaymentSuccess('');

    // Hier würde die Logik zur Weiterleitung zu PayPal oder zur Verarbeitung der Kreditkartenzahlung stehen.
    // In einer echten Anwendung müsstest du eine Backend-Integration haben,
    // die mit der PayPal-API oder einem anderen Zahlungsanbieter interagiert.

    // Simuliere eine erfolgreiche Zahlung nach kurzer Zeit
    setTimeout(() => {
      setProcessingPayment(false);
      if (Math.random() > 0.2) { // 80% Erfolgsrate simulieren
        setPaymentSuccess(`Kauf von ${tokenAmount} Token per ${paymentMethod} erfolgreich!`);
        // Hier könntest du den Benutzer zum Dashboard oder einer Bestätigungsseite weiterleiten.
      } else {
        setPaymentError('Zahlung fehlgeschlagen. Bitte versuche es erneut.');
      }
    }, 2000);
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Row className="w-100">
        <Col md={6} className="mx-auto">
          <Card className="p-4 shadow">
            <Card.Body>
              <h2 className="text-center mb-4">Token kaufen</h2>

              <Form.Group className="mb-3" controlId="formTokenAmount">
                <Form.Label>Anzahl der Token</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={tokenAmount}
                  onChange={handleTokenChange}
                />
                <Form.Text className="text-muted">
                  Bitte wähle die Anzahl der Token, die du kaufen möchtest.
                </Form.Text>
              </Form.Group>

              <div className="mb-3">
                <Form.Label>Zahlungsmethode</Form.Label>
                <ButtonGroup className="w-100">
                  <Button
                    variant={paymentMethod === 'paypal' ? 'primary' : 'outline-primary'}
                    onClick={() => handlePaymentMethodSelect('paypal')}
                  >
                    PayPal
                  </Button>
                  <Button
                    variant={paymentMethod === 'paypal-credit' ? 'primary' : 'outline-primary'}
                    onClick={() => handlePaymentMethodSelect('paypal-credit')}
                  >
                    PayPal Kreditkarte
                  </Button>
                </ButtonGroup>
                {paymentMethod && (
                  <Form.Text className="text-muted">
                    Du hast gewählt: {paymentMethod === 'paypal' ? 'PayPal' : 'PayPal Kreditkarte'}
                  </Form.Text>
                )}
              </div>

              <Button
                variant="success"
                onClick={handlePaymentSubmit}
                disabled={processingPayment || !paymentMethod}
                className="w-100"
              >
                {processingPayment ? 'Zahlung wird verarbeitet...' : 'Bezahlen'}
              </Button>

              {paymentError && (
                <div className="mt-3 text-danger">{paymentError}</div>
              )}

              {paymentSuccess && (
                <div className="mt-3 text-success">{paymentSuccess}</div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Payment;